export function sortByRowPosition(a, b) {
  return (parseInt(a?.position) || 0) - (parseInt(b?.position) || 0);
}
